import React from "react";
import SabhaSaarLogo from "../assets/images/SabhaSaarLogo.png";
import Emblem from "../assets/images/emblem.png";
import Wrapper from "../assets/wrappers/SabhaSaarHeader";
import { useNavigate, useLocation } from "react-router-dom";

const SabhaSaarHeaderPublic: React.FC = () => {
  const navigate = useNavigate();

  const handleHeaderClick = () => {
      navigate("/");
  };

  return (
    <Wrapper>
      <div className="sabhaSaar-header">
        <div
          className="sabhaSaar-header-left"
          onClick={handleHeaderClick}
          style={{ cursor: "pointer" }}
        >
          <img src={Emblem} alt="Emblem_India" />
          <div className="bhashini-skip-translation">
            <h4>Ministry of Panchayati Raj</h4>
            <span>पंचायती राज मंत्रालय</span>
          </div>
        </div>
        <div
          className="sabhaSaar-header-right"
          onClick={handleHeaderClick}
          style={{ cursor: "pointer" }}
        >
          <img src={SabhaSaarLogo} alt="SabhaSaarLogo" />
          <div>
            {/* <h4>SabhaSaar</h4> */}
            <span>"हर चर्चा का सार, सभासार"</span>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default SabhaSaarHeaderPublic;
